'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNotificationsActive = function MdNotificationsActive(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 36.6c-1.9 0-3.4-1.4-3.4-3.2h6.7c0 1.9-1.5 3.2-3.3 3.2z m10-18.2v8.2l3.4 3.4v1.6h-26.8v-1.6l3.4-3.4v-8.2c0-5.2 2.7-9.4 7.5-10.6v-1.2c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v1.2c4.8 1.2 7.5 5.5 7.5 10.6z m3.3-0.9c-0.3-4.5-2.5-8.3-5.9-10.7l2.4-2.3c3.9 3 6.6 7.7 6.8 13h-3.3z m-20.6-10.7c-3.5 2.4-5.7 6.2-6 10.7h-3.3c0.2-5.3 2.9-10 6.8-13z' })
        )
    );
};

exports.default = MdNotificationsActive;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/notifications-active.js
// module id = 3140
// module chunks = 0